import React, { useRef } from 'react'
import { Box } from '@mui/material'
import { Player, Youtube, DefaultUi } from '@vime/react'
import '@vime/core/themes/default.css'
import KinescopeVideoPlayer from './KinescopeVideoPlayer'
import { getVideoType } from '../../utils/functions'

const styles = {
    player: {
        background: '#24282d',
        //height: '450px',
        mb: 3,
        borderRadius: '8px',
        overflow: 'hidden',
    },
}

interface Props {
    link: string
    onStart?: () => void
    onProgress?: (event: CustomEvent<number>) => void
    onPaused?: (event: CustomEvent<boolean>) => void
    currentTime?: number
    externalId?: string
}

const VideoPlayer: React.FC<Props> = ({
    link,
    currentTime = 0,
    onStart,
    onProgress,
    onPaused,
    externalId,
}) => {
    const videoId = link ? new URL(link).pathname.substring(1) : ''
    const player = useRef<HTMLVmPlayerElement>(null)

    if (getVideoType(link) === 'kinescope') {
        return (
            <KinescopeVideoPlayer
                link={link}
                currentTime={currentTime}
                externalId={externalId}
                onStart={onStart}
                onProgress={onProgress}
                onPaused={onPaused}
            />
        )
    }

    return (
        <Box sx={styles.player}>
            <Player
                controls
                ref={player}
                currentTime={currentTime}
                onVmCurrentTimeChange={onProgress}
                onVmPlaybackStarted={onStart}
                onVmPausedChange={onPaused}
            >
                <Youtube videoId={videoId}></Youtube>

                <DefaultUi />
            </Player>
        </Box>
    )
}

export default VideoPlayer
